import styled from 'styled-components';

export const Container = styled.div<any>`
  margin-bottom: 32px;
  position: relative;
  z-index: 9000;
`;
